
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4204_29)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.9809 24.4009V15.641C31.9809 13.7172 30.419 12.1553 28.4952 12.1553H11.5237C9.59992 12.1553 8.03802 13.7172 8.03802 15.641V24.4044C11.1872 24.9918 13.5619 27.7469 13.5619 31.0697C13.5619 34.822 10.5333 37.8506 6.78095 37.8506C3.02857 37.8506 0 34.822 0 31.0697C0 27.7336 2.3938 24.9697 5.56183 24.3974V15.641C5.56183 12.3458 8.24754 9.67914 11.5237 9.67914H28.5142C31.8094 9.67914 34.4761 12.3649 34.4761 15.641V24.4044C37.6253 24.9917 40 27.7469 40 31.0697C40 34.822 36.9714 37.8506 33.2191 37.8506C29.4667 37.8506 26.4381 34.822 26.4381 31.0697C26.4381 27.7403 28.8223 24.9808 31.9809 24.4009ZM6.78095 26.7649C9.16191 26.7649 11.0857 28.6887 11.0857 31.0697C11.0857 33.4506 9.16191 35.3744 6.78095 35.3744C4.4 35.3744 2.47619 33.4506 2.47619 31.0697C2.47619 28.6887 4.4 26.7649 6.78095 26.7649ZM33.2191 26.7649C35.6 26.7649 37.5238 28.6887 37.5238 31.0697C37.5238 33.4506 35.6 35.3744 33.2191 35.3744C30.8381 35.3744 28.9143 33.4506 28.9143 31.0697C28.9143 28.6887 30.8381 26.7649 33.2191 26.7649Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M27.9079 8.84595L22.0697 3.00769C20.9253 1.86332 19.0699 1.86332 17.9255 3.00769L12.0873 8.84596C10.9429 9.99032 10.9429 11.8457 12.0873 12.9901L17.9255 18.8283C19.0699 19.9727 20.9253 19.9727 22.0697 18.8283L27.9079 12.9901C29.0523 11.8457 29.0523 9.99032 27.9079 8.84595Z","fill":"#5D5CFD"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4204_29"}},[_c('rect',{attrs:{"width":"40","height":"40","fill":"white"}})])])])
          )
        }
      }
    